"use strict";

var ensure = function ensure(isValid, eventDef) {
  return function () {
    var event = eventDef.apply(undefined, arguments);
    return isValid(event) ? event : null;
  };
};

module.exports = { ensure: ensure };


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-beacon/utils/ensure.js
// module id = 860
// module chunks = 146